module.exports = __webpack_public_path__ + "static/media/wifi-slash.4b9553f6.svg";